import React, { createContext, useContext, useState, useCallback } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./LevelSectionsUIHelpers";

const LevelSectionsUIContext = createContext();

export function useLevelSectionsUIContext() {
  return useContext(LevelSectionsUIContext);
}

export const LevelSectionsUIConsumer = LevelSectionsUIContext.Consumer;

export function LevelSectionsUIProvider({ levelSectionsUIEvents, children }) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const [ids, setIds] = useState([]);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);
  
  const value = {
    queryParams,
    setQueryParamsBase,
    ids,
    setIds,
    setQueryParams,
    openNewLevelSectionPage: levelSectionsUIEvents.openNewLevelSectionPage,
    openEditLevelSectionPage: levelSectionsUIEvents.openEditLevelSectionPage
  };

  return (
    <LevelSectionsUIContext.Provider value={value}>
      {children}
    </LevelSectionsUIContext.Provider>
  );
}